import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { api } from '../../../Services/API'

import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  UploaddocumentClientRequest,
  UploaddocumentClientResponse,
} from '../../../@types/UploadDocument'
import { useUploadDocumentStore } from '../../../Stores/useUploadDocumentStore'
import { useWarningStore } from '../../../Stores/warningStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: UploaddocumentClientRequest) => {
  const response = await api.post<UploaddocumentClientResponse>(
    API_ROUTES.uploadDocument,
    payload,
  )

  return response.data
}

export const useUploadDocument = () => {
  const { setUploadDocument } = useUploadDocumentStore()
  const { handleErrorRequest } = useErrorRequest()
  const { setWarningOptions } = useWarningStore()
  return useMutation({
    mutationFn: (payload: UploaddocumentClientRequest) => request(payload!),
    onSuccess(data) {
      setUploadDocument(data)
      setWarningOptions({
        type: WARNING_BAR.type.success,
        labelTypes: [t('pages.step7.attachmentDocuments.success')],
      })
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
